<template>
  <Wrapper :team="team">
    <div>
      <!-- Team billing section -->
      <div class="mt-10 divide-y divide-gray-200">
        <div class="space-y-1">
          <h3 class="text-lg leading-6 font-medium text-gray-900">
            Team billing
          </h3>
          <p class="max-w-2xl text-sm text-gray-500">
            Here you'll find your organisation's billing information and payment history.
          </p>
        </div>
        <div class="mt-6">
          <p class="text-gray-500 mt-6 text-sm italic">
            Not yet applicable
          </p>
        </div>
      </div>
      <!-- Team billing section end -->
    </div>
  </Wrapper>
</template>

<script>
import Wrapper from './Wrapper.vue';

export default {
  components: {
    Wrapper,
  },
  props: {
    team: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
    };
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
// #RPT: remove when buttons are connected
button {
    color: lightgray;
    cursor: not-allowed;
}
</style>
